import { DRIVER_CONDITION_ITEMS, VEHICLE_INSPECTION_ITEMS, completedSafetyValues } from './safetyChecks'

export const APP_DATE = '2026-07-17'
export const APP_DATE_JA = '2026年7月17日（金）'

const driverNames = [
  '佐藤 健一', '田中 美咲', '鈴木 大輔', '高橋 翔', '伊藤 裕子', '山本 健太',
  '渡辺 隆', '中村 亮', '小林 誠', '加藤 真一', '吉田 直樹', '山田 和也',
  '佐々木 翔', '山口 美穂', '松本 将之', '井上 貴博', '木村 拓也', '林 直子',
  '清水 大地', '斎藤 優', '阿部 浩司', '森 由佳',
]

export const seedVehicles = [
  ['v01', '品川 100 あ 12-34', '2t平ボディ', 'いすゞ エルフ'],
  ['v02', '横浜 500 い 56-78', 'ライトバン', 'トヨタ プロボックス'],
  ['v03', '足立 400 う 90-12', '4tウイング', '日野 レンジャー'],
  ['v04', '多摩 800 え 34-56', '冷凍車', '三菱ふそう キャンター'],
  ['v05', '川崎 300 お 78-90', 'ワンボックス', 'トヨタ ハイエース'],
  ['v06', '練馬 100 か 11-22', '3tユニック', 'いすゞ フォワード'],
  ['v07', '所沢 400 き 33-44', '2tバン', '日野 デュトロ'],
  ['v08', '相模 100 く 55-66', '4t平ボディ', 'UDトラックス コンドル'],
  ['v09', '千葉 200 せ 77-88', '軽バン', 'スズキ エブリイ'],
  ['v10', '世田谷 500 そ 99-00', '乗用車', 'トヨタ カローラ'],
].map(([id, number, type, model], index) => ({
  id, number, type, model, branch: index < 6 ? '東京営業所' : '湾岸営業所', active: true,
}))

export const seedDrivers = driverNames.map((name, index) => ({
  id: `d${String(index + 1).padStart(2, '0')}`,
  name,
  employeeId: `DRV-${String(index + 1).padStart(3, '0')}`,
  branch: index < 14 ? '東京営業所' : '湾岸営業所',
  vehicleIds: [seedVehicles[index % seedVehicles.length].id, seedVehicles[(index + 1) % seedVehicles.length].id],
  active: true,
}))

const phases = ['業務前', '業務後']
const julyWeekdays = Array.from({ length: 31 }, (_, index) => index + 1).filter((day) => {
  const weekday = new Date(Date.UTC(2026, 6, day)).getUTCDay()
  return weekday >= 1 && weekday <= 5
})

function formatTime(totalMinutes) {
  const hour = Math.floor(totalMinutes / 60)
  const minute = totalMinutes % 60
  return `${String(hour).padStart(2, '0')}:${String(minute).padStart(2, '0')}`
}

function isAlcoholReviewRecord(day, position, phase) {
  return (day === 8 && position === 4 && phase === '業務前')
    || (day === 17 && position === 8 && phase === '業務前')
    || (day === 28 && position === 12 && phase === '業務後')
}

function isSafetyReviewRecord(day, position, phase) {
  return day === 23 && position === 2 && phase === '業務前'
}

function reviewValue(day) {
  if (day === 8) return 0.03
  if (day === 17) return 0.05
  return 0.02
}

export const seedRecords = julyWeekdays.flatMap((day) => {
  const date = `2026-07-${String(day).padStart(2, '0')}`
  const startDriver = ((day - 1) * 3) % seedDrivers.length
  const scheduledDrivers = Array.from({ length: 19 }, (_, position) => ({
    position,
    driver: seedDrivers[(startDriver + position) % seedDrivers.length],
  }))

  return scheduledDrivers.flatMap(({ driver, position }) => phases.map((phase, phaseIndex) => {
    const alcoholReview = isAlcoholReviewRecord(day, position, phase)
    const safetyReview = isSafetyReviewRecord(day, position, phase)
    const review = alcoholReview || safetyReview
    const baseMinutes = phase === '業務前' ? 6 * 60 + 45 : 16 * 60 + 25
    const spread = phase === '業務前' ? 83 : 112
    const time = formatTime(baseMinutes + ((position * (phaseIndex ? 11 : 7) + day) % spread))
    const remoteConfirmation = (day + position + phaseIndex) % 11 === 0
    const instruction = alcoholReview
      ? phase === '業務前' ? '運転中止・再検査／管理者へ連絡' : '管理者へ報告・帰宅手段を確認'
      : safetyReview ? '運転開始前に管理者へ報告・予備車両を確認'
      : 'なし'
    const vehicleInspection = completedSafetyValues(VEHICLE_INSPECTION_ITEMS)
    if (safetyReview) vehicleInspection.meters = 'review'

    return {
      id: `demo-${date.replace(/-/g, '')}-${driver.id}-${phaseIndex === 0 ? 'before' : 'after'}`,
      date,
      time,
      phase,
      driverId: driver.id,
      vehicleId: driver.vehicleIds[day % driver.vehicleIds.length],
      value: alcoholReview ? reviewValue(day) : 0,
      method: (day + position + phaseIndex) % 3 === 0 ? '手入力' : '画像読取',
      presence: alcoholReview,
      visualCheck: alcoholReview ? '顔色・応答を要確認' : '異常なし',
      confirmationMethod: remoteConfirmation ? '電話・音声通話' : '対面',
      checkerId: driver.branch === '東京営業所' ? 'ALC-TOKYO-01' : 'ALC-WANGAN-01',
      confirmer: driver.branch === '東京営業所' ? '鈴木 管理者' : '森 安全運転管理者',
      instruction,
      note: alcoholReview ? '再検査記録を管理者が確認' : safetyReview ? '警告灯が点灯。予備車両へ変更し整備担当へ連絡' : phase === '業務前' ? '始業前確認' : '終業後確認',
      preDriveCheck: phase === '業務前' ? {
        driverCondition: completedSafetyValues(DRIVER_CONDITION_ITEMS),
        vehicleInspection,
        status: safetyReview ? 'review' : 'completed',
        note: safetyReview ? '警告灯が点灯。予備車両へ変更し整備担当へ連絡' : '',
        checkedAt: `${date}T${time}:00+09:00`,
      } : null,
      status: review ? 'review' : 'completed',
      createdAt: `${date}T${time}:00+09:00`,
      audit: [`${time} 本人が記録`, review ? `${time} 自動で要確認判定` : `${time} 管理者確認・記録完了`],
    }
  }))
})

export const seedSettings = {
  companyName: '株式会社ハコバル建材',
  officeName: '東京営業所',
  businessUseCategory: '白ナンバー／自家用貨物（資材配送）',
  checkerModel: '未選定',
  defaultCheckerId: 'ALC-TOKYO-01',
  checkerOperationalStatus: '未設定',
  webhookUrl: '',
  webhookEnabled: false,
  integrations: {
    attendance: { method: '未設定', enabled: false },
    dispatch: { method: '未設定', enabled: false },
    fleet: { method: '未設定', enabled: false },
    gatebell: { method: '未設定', enabled: false },
    maintenance: { method: '未設定', enabled: false },
  },
  apiKeyLabel: 'ALCOLOG-DEMO-2026',
  retentionYears: 1,
  threshold: 0,
  lastSync: null,
}
